export default __webpack_public_path__ + "static/media/wi_8.625df0d3.mp3";